import React from 'react';
import { dispatch } from 'nike-re-framejs';
import { initializeRegistration } from 'nike-ui/src/components/registration/util/config';
import i18n from '@i18n';
import PopupNg from '@/ui/PopupNg';
import Dialog, { DialogBody, DialogTitle } from '@/ui/dialogs/Dialog';
import { registerPopup } from '@/ui/popupRegistrar';
import history from '@/routing/history';
import axios from 'axios';
import { getProperty, getUrl } from '@/common/oldMobile';
import { toWwwForm } from '@/_http/utils';
import { navigate } from '@/routing';
import { HOME } from '@/routing/routes';
import './registration/OnbRegistration.less';
import { deepMerge } from 'nike-ui/src/common/immutable/merge';
import { sendUsingForm } from '@/common/client';
import { fetchProfile } from '@/myprofile/handlers';

initializeRegistration(function() {
    return {
        i18n,
        useDynamicPageHeightFix: function() {
            return 99;
        },
        pageClass: '',
        onboardingApi: '/api/onboarding',
        affidavitResidenceMandatory: getProperty('affidavitResidenceMandatory'),
        onError(error) {
            dispatch(['ui.showMasterError', 'error.unexpected.message', 'error.unexpected.title', null]);
        },
        onPageChanged(url) {
            window.scrollTo(0, 0);
            history.replace(url);
        },

        doLoginAttempt(userName, password) {
            return axios.post(getUrl('XHR_LOGIN'), toWwwForm({ userName, password }));
        },

        onLogin() {
            sendUsingForm('/', { loginRequest: 'loginRequest' });
        },

        gotoLoginForm() {
            navigate(HOME, null, { prihlasenie: undefined });
        },

        gotoHomepage() {
            navigate(HOME);
        },

        openDialog: function(title, body, options) {
            const close = () => PopupNg.dispatcher.close('dialog/onb/generic');
            PopupNg.dispatcher.open('dialog/onb/generic', {
                title,
                body,
                options,
                close
            });
            return close;
        },

        openArticle: function(code, title) {
            PopupNg.dispatcher.open('dialog/article', { articleCode: code, type: 'marketing' });
        },

        openClientParamChangeVerificationModal: function(forcedActionCrm) {
            PopupNg.dispatcher.open('client-param-change-verification', { forcedActionCrm });
        },

        setForcedActions: function(forcedActions, db) {
            return db.updateIn(['account', 'userData', 'forcedActions'], existing =>
                deepMerge(existing, forcedActions)
            );
        },
        setForcedActionsCrm: function(forcedActionsCrm, db) {
            return db.updateIn(['account', 'userData', 'forcedActionsCrm'], existing =>
                deepMerge(existing, forcedActionsCrm)
            );
        },
        refreshUserData: function() {
            fetchProfile();
        }
    };
});
registerPopup('dialog/onb/generic', popup => <GenericDialog {...popup.get('data')} />);

function GenericDialog({ title, body, close, options }) {
    return (
        <Dialog className={options?.className}>
            {title ? <DialogTitle>{title}</DialogTitle> : null}
            <DialogBody>{React.cloneElement(body, { close })}</DialogBody>
        </Dialog>
    );
}
